(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('nm-config').textContent);
  const root = config.root.replace(/\/?$/, '/');
  const all = selector => [...document.querySelectorAll(selector)];
  let busy = false;
  function selectKit(input) {
    if (!input) return;
    all('input[name="kit"]').forEach(el => {
      el.checked = el.value === input.value;
      el.closest('.kit-option').classList.toggle('selected', el.checked);
    });
    const form = document.getElementById('MemoryProductForm');
    if (form) form.querySelector('[name="id"]').value = input.value;
    all('.add-selected').forEach(button => {
      button.textContent = `${config.add} · ${input.dataset.price}`;
      button.disabled = input.dataset.available !== 'true';
      if (button.disabled) button.textContent = config.soldOut;
    });
    const sticky = document.getElementById('sticky-kit');
    if (sticky) sticky.textContent = `${input.dataset.title} · ${input.dataset.price}`;
    const helper = document.getElementById('kit-helper');
    if (helper) helper.textContent = input.closest('label').querySelector('.kit-text small').textContent;
  }
  function init() {
    selectKit(document.querySelector('input[name="kit"]:checked') || document.querySelector('input[name="kit"]'));
    all('[data-add-kit]').forEach(b => { b.disabled = b.dataset.available !== 'true'; });
    updateSticky();
  }
  document.addEventListener('change', event => {
    if (event.target.matches('input[name="kit"]')) selectKit(event.target);
    if (event.target.id === 'MemoryCountry') event.target.form.querySelector('[name="language_code"]').value = event.target.value === 'FR' ? 'fr' : 'en';
  });
  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[href^="#"]');
    if (anchor && anchor.hash && !document.getElementById(anchor.hash.slice(1))) {event.preventDefault();location.assign(config.root+anchor.hash);return;}
    const thumb = event.target.closest('[data-gallery]');
    if (!thumb) return;
    const source = thumb.querySelector('img');
    const main = document.getElementById('gallery-image');
    main.src = source.currentSrc || source.src;
    main.alt = thumb.dataset.alt;
    document.getElementById('gallery-caption').textContent = thumb.querySelector('span').textContent;
    document.getElementById('image-counter').textContent = `${String(Number(thumb.dataset.gallery)+1).padStart(2,'0')} / ${String(all('[data-gallery]').length).padStart(2,'0')}`;
    all('[data-gallery]').forEach(el => {el.classList.toggle('active',el===thumb);el.setAttribute('aria-pressed',String(el===thumb));});
  });
  document.addEventListener('input', event => {
    if (event.target.id === 'restore-range') document.getElementById('comparison-image').style.setProperty('--split', event.target.value+'%');
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    const button = event.submitter;
    const previous = button?.textContent;
    if (button) {button.disabled=true;button.textContent=config.adding;}
    const error = document.querySelector('.nm-cart-error');
    if (error) error.textContent='';
    try {
      const response = await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      let result;
      try { result = await response.json(); } catch { throw new Error(config.error); }
      if (!response.ok) throw new Error(result.description || config.error);
      location.assign(config.cart);
    } catch (failure) {
      if (error) {error.textContent=failure.message || config.error;error.scrollIntoView({block:'center',behavior:'smooth'});}
      if(button){button.disabled=false;button.textContent=previous;}
      busy=false;
    }
  });
  let scheduled = false;
  function updateSticky(){
    const box=document.getElementById('buy-box'), bar=document.getElementById('sticky-buy');
    if(bar) bar.hidden=!box || box.getBoundingClientRect().bottom>=0;
    scheduled=false;
  }
  window.addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(updateSticky);}},{passive:true});
  window.addEventListener('resize',updateSticky);
  document.addEventListener('shopify:section:load',init);
  init();
})();
